export default "__VITE_ASSET__e391e8a7__"